import { createFileRoute } from '@tanstack/react-router'

import { SetPasswordForm } from '@/features/auth/components/set-password-form'

/**
 * The recovery link page. The path is compiled into the backend
 * (`auth.frontend.reset_password_path`) — renaming it 404s every reset email.
 */
export const Route = createFileRoute('/reset-password')({
  component: () => (
    <SetPasswordForm
      title="Reset your password"
      submitLabel="Reset Password"
      showBackLink
      confirmation={{
        title: 'Password changed',
        description: 'Your password has been changed successfully',
        actionLabel: 'Back to login',
      }}
    />
  ),
})
